import { Component, ElementRef, EventEmitter, Inject, Input, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { L10n, L10nBase } from '@skylab-angular-shared/core';
import { DatepickerValueAccessorDirective, InsDatepickerDirective, NumericValueAccessorDirective, ValidateDirective, ValidateInnerDirective } from '@skylab-angular-shared/ui';

@Component({
    selector: 'skl-due-date',
    templateUrl: './due-date.component-ins.html',
    styles: [`
        :host {
            width: 100%;
        }

        .due-date {
            display: inline-flex;
            flex-wrap: wrap;
            width: inherit;
        }

        .due-date__item {
            display: inline-flex;
            align-items: baseline;
        }

        .due-date__date {
            flex: 1;
        }

        .due-date__text {
            white-space: nowrap;
        }
    `],
    imports: [NumericValueAccessorDirective, FormsModule, ValidateDirective, ValidateInnerDirective, InsDatepickerDirective, DatepickerValueAccessorDirective]
})
export class DueDateInsComponent {
    @Input() public day!: number;

    @Input() public date!: Date;

    @Input() public dayValidationKey!: string | null | undefined;

    @Input() public dateValidationKey!: string | null | undefined;

    @Output() public dayChange = new EventEmitter<number>();

    @Output() public dateChange = new EventEmitter<Date>();

    @ViewChild('datepicker') private datepicker!: ElementRef<HTMLInsDatepickerElement>;

    public constructor(
        @Inject(L10n) private readonly l10n: L10nBase,
        private readonly elementRef: ElementRef,
    ) {

        this.elementRef.nativeElement.setPopoverAnchor = (element: HTMLElement) => {
            this.datepicker.nativeElement.setPopoverAnchor(element);
        };
    }

    public ngOnDestroy(): void {
        this.elementRef.nativeElement.setPopoverAnchor = null;
    }

    public get dayText(): string {
        return this.day === 1
            ? this.l10n._T('scenes.shared.control.due-date.day')
            : this.l10n._T('scenes.shared.control.due-date.days');
    }

    public onDateChange(val: Date): void {
        this.date = val;
        this.dateChange.emit(this.date);
    }

    public onDayChange(val: number): void {
        this.day = val;
        this.dayChange.emit(this.day);
    }
}
